import config from './config';
import { dataReturn } from './utils';

const URL_BASE = config.hostApiTalent;

export async function GetCourses() {
  const API_URL = `${URL_BASE}/courses`;
  const requestOptions = {
    method: 'GET',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function GetCourseById(id) {
  const API_URL = `${URL_BASE}/courses/${id}`;
  const requestOptions = {
    method: 'GET',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function GetCourseByUser(userId, courseId) {
  const API_URL = `${URL_BASE}/courses/users/${courseId}/${userId}`;
  const requestOptions = {
    method: 'GET',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function GetTopicById(idTopic) {
  const API_URL = `${URL_BASE}/topics/${idTopic}`;
  const requestOptions = {
    method: 'GET',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function AddRollerCourse(idUser, idCourse) {
  const API_URL = `${URL_BASE}/inscriptions`;
  const requestOptions = {
    method: 'POST',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ idUser, idCourse }),
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function GetInscription(idUser, idCourse) {
  const API_URL = `${URL_BASE}/inscriptions/${idUser}/${idCourse}`;
  const requestOptions = {
    method: 'GET',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function AddNote(text, idUser, idCourse, idTopic, idLesson) {
  const API_URL = `${URL_BASE}/notes`;
  const requestOptions = {
    method: 'POST',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
    body: JSON.stringify({
      text, idUser, idCourse, idTopic, idLesson,
    }),
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function UpdateNote(id, text) {
  const API_URL = `${URL_BASE}/note/update`;
  const requestOptions = {
    method: 'POST',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
    body: JSON.stringify({ id, text }),
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function GetNotesByLesson(idUser, idLesson) {
  const API_URL = `${URL_BASE}/notes/${idUser}/${idLesson}`;
  const requestOptions = {
    method: 'GET',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function GetLessonById(idLesson) {
  const API_URL = `${URL_BASE}/lessons/${idLesson}`;
  const requestOptions = {
    method: 'GET',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function finishLesson(dataLesson) {
  const API_URL = `${URL_BASE}/lessons/update`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(dataLesson),
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function updateStatusLesson(dataLesson) {
  const API_URL = `${URL_BASE}/lesson/update`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(dataLesson),
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function GetMentors() {
  const API_URL = `${URL_BASE}/mentors`;
  const requestOptions = {
    method: 'GET',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
  };
  const response = await fetch(API_URL, requestOptions);
  const data = await response.json();
  const mentorsOrderedByCreatedAt = data.data.sort((a, b) => {
    if (Number(a.createdAt) > Number(b.createdAt)) return 1;
    if (Number(b.createdAt) > Number(a.createdAt)) return -1;
    return 0;
  });
  return dataReturn(response, mentorsOrderedByCreatedAt);
}

export async function AddRMeeting(idUser, idMentor, userEmail, mentorEmail, date) {
  const API_URL = `${URL_BASE}/meetings`;
  const requestOptions = {
    method: 'POST',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
    body: JSON.stringify({
      idUser, idMentor, userEmail, mentorEmail, date,
    }),
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function UpdateMentorAvailability(idMentor, availability) {
  const API_URL = `${URL_BASE}/mentors/update/availability`;
  const requestOptions = {
    method: 'POST',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
    body: JSON.stringify({
      idMentor, availability,
    }),
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function SendEmailToMentor(mentorName, userName, mentorEmail, userEmail, date) {
  const API_URL = `${URL_BASE}/mentors/email`;
  const requestOptions = {
    method: 'POST',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
    body: JSON.stringify({
      mentorName, userName, mentorEmail, userEmail, date,
    }),
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function UpdateFilePracticalCaseByUser(dataFilePracticalCase) {
  const API_URL = `${URL_BASE}/cases/update/file`;
  const requestOptions = {
    method: 'POST',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
    body: JSON.stringify(dataFilePracticalCase),
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function UpdateAnswerQuizzByUser(dataAnswersQuizz) {
  const API_URL = `${URL_BASE}/quizzes/update/answers`;
  const requestOptions = {
    method: 'POST',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
    body: JSON.stringify(dataAnswersQuizz),
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function UpdateFileFinalProjectByCourse(dataFileFinalProject) {
  const API_URL = `${URL_BASE}/projects/update/file`;
  const requestOptions = {
    method: 'POST',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
    body: JSON.stringify(dataFileFinalProject),
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}

export async function GetUserInscription(subUser) {
  const API_URL = `${URL_BASE}/inscriptions/${subUser}`;
  const requestOptions = {
    method: 'GET',
    headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` },
  };
  const resp = await fetch(API_URL, requestOptions);
  const data = await resp.json();
  return dataReturn(resp, data);
}
